import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-stock-validation-dialog',
  template: `
    <h2 mat-dialog-title>⚠ Stock Shortage - Approval Blocked</h2>
    <mat-dialog-content>
      <p>The following items have insufficient stock in the warehouse. Please adjust the quantities or replenish inventory before approving.</p>
      <p>{{ data.message }}</p>
      <div class="stock-table" *ngIf="data.errorDetails?.length; else messages">
        <table>
          <thead><tr><th>Sales Order #</th><th>Location</th><th>Item Code &amp; Name</th><th>Requested Qty</th><th>Batch Demand</th><th>Available Stock</th><th>Batch Shortage</th></tr></thead>
          <tbody><tr *ngFor="let row of data.errorDetails">
            <td>{{ row.tranId }}</td><td>{{ row.location }}</td><td>{{ row.itemCode }} - {{ row.itemName }}</td>
            <td>{{ row.requestedQty }} {{ row.uomCode || row.uom }}</td>
            <td>{{ row.batchTotalQty }} {{ row.uomCode || row.uom }}</td>
            <td>{{ row.availableQty }} {{ row.uomCode || row.uom }}</td>
            <td>{{ row.shortageQty }} {{ row.uomCode || row.uom }}</td>
          </tr></tbody>
        </table>
        <p class="mt-3">Batch shortage is shared by orders for the same location, item and unit; do not add repeated shortages together.</p>
      </div>
      <ng-template #messages><ul><li *ngFor="let error of data.errors">{{ error }}</li></ul></ng-template>
    </mat-dialog-content>
    <mat-dialog-actions align="end"><button type="button" class="btn btn-primary" (click)="dialog.close()" cdkFocusInitial>Close</button></mat-dialog-actions>
  `,
  styles: [`.stock-table { overflow-x: auto; } table { width: 100%; border-collapse: collapse; }
    th, td { padding: 10px; text-align: left; border-bottom: 1px solid #ddd; } th { background: #fff3cd; }`]
})
export class StockValidationDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialog: MatDialogRef<StockValidationDialogComponent>) {}
}
